import { cn } from "cy-fe/src/utils/cn";

export function HeaderDescription({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <p className={cn("px-4 text-center text-sm text-gray-700", className)}>
      {children}
    </p>
  );
}
